import { Box, SxProps, Theme } from '@mui/material'
import { LoadingSpinner } from 'assets/svg/loadingSpinner'
import { theme } from 'config'
import React from 'react'

export interface ILoadingProps {
  sx?: SxProps<Theme>
}

export const Loading = (props: ILoadingProps): JSX.Element => {
  return (
    <Box
      maxWidth='100%'
      sx={Object.assign(
        {
          margin: 0,
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
        },
        props.sx
      )}
    >
      <LoadingSpinner color={theme.palette.green.main} height={70} width={70} />
    </Box>
  )
}
